import './App.css';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Homepage from './pages/Homepage';
import Projectspage from './pages/Projectspage';
import ProjectDetailspage from './pages/ProjectDetailspage';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route exact path="/projects" component={Projectspage} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/projects/:id" component={ProjectDetailspage} />
      </Switch>
    </Router>
  );
}

export default App;
